<template>
  <div
    :class="['h-full container', classStyle]"
    style="padding: 16px 20px"
  >
    <div
      v-if="header"
      ref="header"
      class="content-header p-b-16"
    >
      <slot name="header" />
    </div>
    <div v-if="filterItems.length > 0 && showFilterHeader">
      <div class="filter-header">
        <div class="filter-items">
          <div
            v-for="(item, index) in filterItems.slice(0, 4)"
            :key="index"
            class="filter-item"
          >
            <div
              class="filter-item-text"
              :title="item.renderItemTitle"
              v-html="item.renderItem"
            />
            <div
              class="mi-close-small"
              @click="handleClearFilterItem(item.item, index)"
            />
          </div>
          <div
            v-if="filterItems.length > 4"
            id="filterItemExpand"
            class="filter-item cursor-pointer"
            @click="showPopover = true"
          >
            <div class="circle" />
            <div class="circle" />
            <div class="circle" />
          </div>
        </div>
        <ms-popover
          v-model="showPopover"
          target="#filterItemExpand"
          :is-custom-postition="false"
          position="bottom"
          :width="300"
        >
          <template #content>
            <div class="content-popover">
              <div class="filter-items">
                <div
                  v-for="(item, index) in filterItems.slice(4)"
                  :key="index"
                  class="filter-item"
                >
                  <div
                    class="filter-item-text"
                    :title="item.renderItemTitle"
                    v-html="item.renderItem"
                  />
                  <div
                    class="mi-close-small"
                    @click="handleClearFilterItem(item.item, index)"
                  />
                </div>
              </div>
            </div>
          </template>
        </ms-popover>
        <div
          class="clear-all"
          @click="handleClearAllFilterItems"
        >
          {{ $t("i18nCommon.DeleteAll") }}
        </div>
      </div>
    </div>
    <div
      ref="content"
      class="content-main"
      :style="{ background: contentBg, overflow: overflowScroll }"
    >
      <div
        :class="[
          'h-full',
          { 'w-full': !showFilter },
          { 'w-filter': showFilter }
        ]"
        :style="{ width: showFilter ? width : '' }"
      >
        <slot
          ref="content"
          name="content"
        />
      </div>
      <DxResizable
        v-show="showFilter"
        :width="showFilter ? sidebarWidth : 0"
        :max-width="600"
        :min-width="250"
        handles="left"
        height="100%"
        :on-resize.sync="onResizeSidebar"
        :class="'m-l-16 resize1'"
      >
        <ms-filter
          ref="msFilter"
          :class="['h-full', 'w-full']"
          :options="options"
          :show-filter.sync="showFilter"
          :filter-code="filterCode"
          :reset-filter="resetFilter"
          :filter-class="filterClass"
          :use-full-text-search="useFullTextSearch"
          @closeFilter="closeFilter"
          @disabledFilter="disabledFilter"
          @onFilter="onFilter"
          @onApply="handleApplyClick"
        />
      </DxResizable>
    </div>
  </div>
</template>
<script>
import { DxResizable } from "devextreme-vue/resizable";
import SystemAPI from "@/apis/components/SystemAPI.js";

export default {
  name: "BaseContentArea",
  components: {
    DxResizable
  },
  props: {
    header: {
      type: [String, Boolean],
      default: true
    },
    overflowScroll: {
      type: [String, Boolean],
      default: false
    },
    contentBg: {
      type: String,
      default: "white"
    },
    options: {
      type: Array,
      default: () => []
    },
    showFilter: {
      type: [Boolean, String],
      default: false
    },
    //Class tùy chỉnh base chung
    classStyle: {
      type: String,
      default: ""
    },
    //Class tùy chỉnh filter
    classFilter: {
      type: String,
      default: ""
    },
    filterCode: {
      type: String,
      default: ""
    },
    resetFilter: {
      type: Boolean,
      default: false
    },
    // Ẩn hiện chi tiết lọc
    showFilterHeader: {
      type: Boolean,
      default: true
    },
    filterClass: {
      type: String,
      default: ""
    },
    allowResizeFilter: {
      type: Boolean,
      default: true
    },
    // có sử dụng fulltext search
    useFullTextSearch: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      filterItems: [],
      showPopover: false,
      sidebarWidth: 260,
      width: "calc(100% - 260px + 16px)"
    };
  },
  created() {
    let userInfor = this.$store.getters.userInfor;
    // if(this.allowResizeFilter) {
    //   this.sidebarWidth = userInfor.UserOptions.SidebarWidth || 260;
    // } else {
    //   this.sidebarWidth = 260;
    // }
    // this.width = `calc(100% - ${this.sidebarWidth + 16}px) !important`;
  },
  mounted() {
    if (this.$refs.content) {
      this.$refs.content.style.height = `calc(100vh - ${this.$refs.content.getBoundingClientRect().top + 16}px)`;
    }
  },
  updated() {
    if (this.$refs.content) {
      this.$refs.content.style.height = `calc(100vh - ${this.$refs.content.getBoundingClientRect().top + 16}px)`;
    }
  },
  methods: {
    closeFilter() {
      this.$emit("closeFilter");
      this.$emit("update:showFilter", false);
    },
    disabledFilter() {
      this.$emit("disabledFilter");
      this.filterItems = [];
    },
    onFilter(e) {
      this.$emit("onFilter", e);
    },
    /**
     * Gọi khi DxResizable được kéo đổi kích thước
     * Created by DQTrung on 12/4/2021
     * Updated BY NTSON2 Lưu lại hành động người dùng
     */
    onResizeSidebar(e) {
      if (this.allowResizeFilter) {
        this.sidebarWidth = e.width;
        this.width = `calc(100% -  ${this.sidebarWidth + 16}px) !important`;
        clearTimeout(this.reSizeFilter);
        this.reSizeFilter = setTimeout(() => {
          let userInfor = this.$store.getters.userInfor;
          userInfor.UserOptions.SidebarWidth = this.sidebarWidth;
          SystemAPI.saveUserOption({
            SidebarWidth: this.sidebarWidth
          }).then(res => {});
        }, 1000);
      }
    },
    /**
     * Hàm xử lý khi bấm button Áp dụng
     * created by pdthien 18.02.2021
     */
    handleApplyClick(val) {
      this.filterItems = val;
    },
    /**
     * Hàm xử lý khi bấm button xóa tất cả filter items
     * created by pdthien 18.02.2021
     */
    handleClearAllFilterItems() {
      this.$refs.msFilter.close();
      this.filterItems = [];
    },
    /**
     * Hàm xử lý khi bấm button xóa 1 filter item
     * created by pdthien 18.02.2021
     */
    handleClearFilterItem(item, index) {
      this.filterItems.splice(index, 1);
      item.isChecked = false;
      this.$refs.msFilter.handleRemoveItemFilter(item.index);
    }
  }
};
</script>
<style lang="scss" scoped>
.content-main {
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
}

.content-main.overflowHidden {
  overflow: hidden;
}

.container {
  // width: 100vw;
  display: flex;
  flex-direction: column;
}
.w-filter {
  width: calc(100% - 260px);
}
.filter-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  border-radius: 4px;
  background: white;
  margin-bottom: 8px;
  padding: 0 8px;
  .filter-items {
    display: flex;
    align-items: center;
    width: calc(100% - 65px);
    .filter-item {
      display: flex;
      align-items: center;
      height: 32px;
      border-radius: 4px;
      padding: 8px;
      background: #ebebeb;
      margin-right: 8px;
      max-width: calc(20% - 10px);
      .mi-close-small {
        cursor: pointer;
        margin-left: 4px;
      }
      .filter-item-text {
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
  .clear-all {
    cursor: pointer;
    color: #ef292f;
  }
}
.circle {
  width: 5px;
  height: 5px;
  border: 0.2px solid #707070;
  background-color: #fff;
  border-radius: 50%;
  margin-right: 2px;
}
.resize1 {
  transform: none !important;
}
.content-popover {
  padding-bottom: 8px;
  padding-left: 8px;
  .filter-items {
    .filter-item {
      display: flex;
      align-items: center;
      height: 32px;
      border-radius: 4px;
      padding: 8px;
      background: #ebebeb;
      margin-right: 8px;
      max-width: 100%;
      margin-top: 8px;
      .mi-close-small {
        cursor: pointer;
        margin-left: 4px;
      }
      .filter-item-text {
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
}

::v-deep .grid-container {
  td {
    border: none !important;
  }

  .dx-datagrid-headers {
    border-bottom: 2px solid #ddd !important;
    table {
      tbody {
        tr {
          border: none !important;
        }
      }
    }
  }
}
</style>
